import reusables from '@styles/theme/reusables';
import theme from '@styles/theme';
export default {
  section: (column = false, isLoading = false) => ({
    display: 'flex',
    height: '100vh',
    flexDirection: column ? 'column' : 'row',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    overflowY: column || isLoading ? 'hidden' : 'auto',
    overflowX: 'hidden',
    padding: ['24px 6px 48px 16px', '24px 6px 48px 16px', '24px 4px 64px 24px', '24px 4px 64px 24px', '24px 20px 64px 24px'],
    backgroundColor: column ? 'neutralWhite' : 'lightGrey300'
  }),
  storesContainer: {
    width: '100%',
    maxWidth: '1530px',
    height: 'auto',
    margin: '0 auto',
    boxSizing: 'border-box',
    overflowY: 'auto',
    paddingLeft: '4px',
    ...reusables.scrollbar()
  },
  storesContent: (column = false, isLoading = false) => ({
    width: '100%',
    minHeight: 'calc(100vh - 400px)',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: isLoading ? 'center' : 'flex-start',
    alignSelf: 'stretch',
    flexDirection: column ? 'column' : 'row',
    justifyContent: column && !isLoading ? 'flex-start' : 'center',
    pt: ['8px', '8px', '8px', '8px', '24px'],
    pb: '20px',
    pr: ['10px', '10px', '10px', '10px', '20px'],
    mt: 16,
    gap: 'initial',
    overflowY: column ? 'hidden' : 'auto',
    overflowX: 'hidden',
    ...reusables.scrollbar()
  }),
  divider: {
    display: ['none', 'none', 'none', 'none', 'block'],
    width: '100%;',
    height: '1px',
    backgroundColor: 'lightGrey700'
  },
  findAnotherButtonContainer: {
    mt: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start'
  },
  titleContainer: () => ({
    width: 'calc(100% - 32px)',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    alignSelf: 'stretch',
    flexDirection: 'row',
    mt: 20,
    mb: 20,
    '& button:first-of-type': {
      pl: 16,
      pr: 16,
      ...reusables.mainTransition('padding-left, padding-right')
    },
    '&:hover': {
      '& button:first-of-type': {
        pl: 0,
        pr: 32
      }
    }
  }),
  title: {
    color: theme.rawColors.darkGrey700,
    display: 'flex',
    alignItems: 'start',
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text
  },
  subTitle: {
    color: theme.rawColors.darkGrey500,
    display: 'flex',
    alignItems: 'start',
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    marginBottom: '16px',
    pl: '8px'
  },
  checkbox: () => ({
    display: 'flex',
    flex: 1,
    mt: `8px`,
    label: {
      cursor: 'pointer',
      display: 'inline-flex',
      fontSize: theme.fontSizes.smallText
    },
    '&:last-child': {
      mb: 0
    }
  })
};